<template>
  <div>

    <!-- Alert: No item found -->
    <b-alert
      variant="success"
      :show="!userData"
    >
      <h4 class="alert-heading">
        Data is loading...
      </h4>
    </b-alert>

    <template v-if="userData">
      <!-- First Row -->
      <b-row>
        <b-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
        >
          <b-card
            no-body
            class="card-employee-task"
          >
            <b-card-header
              class="details-header"
            >
              <b-card-title>{{ $t('DEBTIA_CONTACT_DETAILS') }}</b-card-title>
              <b-button
                :to="{ name: 'contacts-edit', params: { id: userData.data.id } }"
                variant="primary"
              >
                {{ $t('DEBTIA_EDIT_CONTACT') }}
              </b-button>
            </b-card-header>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
        >
          <user-view-user-info-card :user-data="userData" />
        </b-col>
      </b-row>
    </template>

  </div>
</template>

<script>
import store from '@/store'
import router from '@/router'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  BRow, BCol, BAlert,
  // BLink,
  BCard, BCardHeader, BCardTitle, BButton,
} from 'bootstrap-vue'
// import InvoiceList from '@/views/apps/invoice/invoice-list/InvoiceList.vue'
import contactStoreModule from '../contactStoreModule'
import UserViewUserInfoCard from './UserViewUserInfoCard.vue'
// import ContactDetailsPortion from './ContactDetailsPortion.vue'

console.log('UserViewUserInfoCard', UserViewUserInfoCard)
export default {
  components: {
    BRow,
    BCol,
    BAlert,
    // BLink,
    BCard,
    BCardHeader,
    BCardTitle,
    BButton,
    // Local Components
    UserViewUserInfoCard,
    // ContactDetailsPortion,
    // InvoiceList,
  },
  data() {
    return {
      InvoiceList: [],
    }
  },
  setup() {
    const userData = ref(null)

    const USER_APP_STORE_MODULE_NAME = 'app-contact'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, contactStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    store.dispatch('app-contact/fetchContact', { id: router.currentRoute.params.id })
      .then(response => {
        console.log('response ', response)
        userData.value = response.data
      })
      .catch(error => {
        if (error.response.status === 404) {
          userData.value = undefined
        }
      })

    return {
      userData,
    }
  },
}
</script>

<style>
.details-header {
  padding: 10px 15px 10px 15px !important;
}
</style>
